/**
 * SC Specs Tabs — Custom element for tabbed specification panels.
 *
 * Handles tab switching: clicking a tab button activates the matching
 * panel and deactivates all others. First tab is active by default
 * (set in the server-rendered HTML via `is-active` classes).
 */

if (!customElements.get('mc-specs-tabs')) {
  class ScSpecsTabs extends HTMLElement {
    constructor() {
      super();
      this._onTabClick = this._onTabClick.bind(this);
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-spec-tab]');
      this.panels = this.querySelectorAll('[data-spec-panel]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this._onTabClick);
      });
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this._onTabClick);
      });
    }

    /**
     * Switches to the clicked tab and reveals the matching panel.
     * @param {Event} event - The click event from a tab button.
     */
    _onTabClick(event) {
      const clickedTab = event.currentTarget;
      const targetKey = clickedTab.getAttribute('data-spec-tab');

      // Deactivate all tabs
      this.tabs.forEach((tab) => {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-selected', 'false');
      });

      // Activate clicked tab
      clickedTab.classList.add('is-active');
      clickedTab.setAttribute('aria-selected', 'true');

      // Hide all panels, show matching one
      this.panels.forEach((panel) => {
        if (panel.getAttribute('data-spec-panel') === targetKey) {
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
        }
      });
    }
  }

  customElements.define('mc-specs-tabs', ScSpecsTabs);
}
